"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
//Estilo do componente PPTextField
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function (Theme) {
    return (0, styles_1.createStyles)({
        '@keyframes progress': {
            '0%': {
                backgroundPosition: '0 0'
            },
            '100%': {
                backgroundPosition: '-70px 0'
            }
        },
        uploadErrorTypography: {
            color: '#2B304F',
            fontFamily: 'Inter',
            fontWeight: 600,
            fontSize: 14,
        },
        uploadErrorGrid: {
            alignContent: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            fontFamily: 'Inter'
        },
        uploadErrorItem: {
            alignContent: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            fontFamily: 'Inter',
        },
        circularProgressLabelCP: {
            color: "#B8CCEA"
        },
        circularProgressLabel1: {
            backgroundColor: '#B8CCEA',
            width: 90,
            height: 90,
            borderRadius: '50%',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'Inter',
        },
        circularProgressLabel2: {
            backgroundColor: '#FAFAFA',
            width: 85,
            height: 85,
            borderRadius: '50%',
            fontFamily: 'Inter',
            alignItems: 'center',
            justifyContent: 'center'
        },
        progressBarTypo1: {
            color: '#2B304F',
            fontFamily: 'Inter',
            fontSize: 14,
            fontWeight: 600,
            marginTop: 16,
        },
        progressBarGrid: {
            paddingTop: 0
        },
        progressBarTypo2: {
            color: '#2B304F',
            fontFamily: 'Inter',
            fontSize: 14,
            fontWeight: 600,
        },
        progressBarButton: {
            marginTop: 50,
            backgroundColor: '#B8CCEA',
            textTransform: 'none',
            fontFamily: 'Inter',
            fontSize: 14,
            fontWeight: 600,
            paddingTop: 11,
            paddingBottom: 11,
            paddingRight: 20,
            paddingLeft: 20,
        },
        uploaderContainerDashed: {
            backgroundColor: '#FFFFFF',
            border: '3px dotted #B8CCEA',
            borderRadius: 8,
            display: 'flex',
            outline: 'none',
            padding: 60,
            textAlign: 'center',
            cursor: 'pointer'
        },
        uploaderNoFileGrid: {
            backgroundColor: '#FAFAFA',
            width: 90,
            height: 90,
            borderRadius: '50%',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 10,
        },
        uploaderNoFileTypo: {
            color: '#2B304F',
            fontFamily: 'Inter',
            fontWeight: 600,
            fontSize: 14,
            marginTop: 16,
        },
        uploaderButton1: {
            paddingTop: 11,
            paddingBottom: 11,
            paddingRight: 20,
            paddingLeft: 20,
            marginTop: 50,
            textTransform: 'none',
            fontFamily: 'Inter',
            fontSize: 14,
            backgroundColor: '#B8CCEA',
            fontWeight: 600,
        },
        uploaderButton2: {
            marginTop: 50,
            textTransform: 'none',
            fontFamily: 'Inter',
            fontSize: 14,
            backgroundColor: '#B8CCEA',
            fontWeight: 600,
            paddingTop: 11,
            paddingBottom: 11,
            paddingRight: 20,
            paddingLeft: 20,
        },
        active: {
            animation: '$progress 2s linear infinite !important',
            backgroundImage: "repeating-linear-gradient(-45deg, ".concat(Theme.palette.background.paper, ", ").concat(Theme.palette.background.paper, " 25px, ").concat('#FAFDFF', " 25px, ").concat('#FAFDFF', " 50px)"),
            backgroundSize: '150% 100%',
            border: '2px solid #B8CCEA',
            padding: 60,
            backgroundColor: '#FFFFFF',
            borderRadius: 8
        },
        fontFamily: {
            fontFamily: "Inter",
            fontSize: 14,
        }
    });
});
